module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pIX"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_vm._v("Plates")]), _vm._v(" "), _c('p', {
    staticClass: "nl-f"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate1"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("1.")])]), _vm._v("Bronze gilt cuirass from Ksour es-Saf, Tunisia, "), _c('i', [_vm._v("c")]), _vm._v(". third century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BCE")]), _vm._v(". © Tunis, Musée National du Bardo.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate2"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("2.")])]), _vm._v("View from Eryx towards Drepanum (Trapani) and the Aegates Islands. Author’s photograph.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate3"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("3.")])]), _c('i', [_vm._v("The Oath of Hannibal")]), _vm._v(" by Benjamin West, 1770. Royal Collection Trust © Her Majesty Queen Elizabeth II 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate4"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("4.")])]), _c('i', [_vm._v("The Oath of Hannibal")]), _vm._v(", eighteenth-century cartoon. Courtesy of the Trustees of the British Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate5"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("5.")])]), _vm._v("Punic di-shekel showing Melqart (possibly Hamilcar) with club on obverse and an elephant and rider on reverse, dated "), _c('i', [_vm._v("c")]), _vm._v(". 237–209 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BCE")]), _vm._v(". Courtesy of the Trustees of the British Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate6"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("6.")])]), _c('i', [_vm._v("Hannibal Crossing the Alps")]), _vm._v(" by Heinrich Leutemann, 1866, etching, hand coloured. Held in the public domain at Yale University Art Gallery.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate7"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("7.")])]), _c('i', [_vm._v("Hannibal with the head of Hasdrubal")]), _vm._v(", Giambattista Tiepolo, 1725–1730. © Kunsthistorisches Museum, Vienna.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate8"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("8.")])]), _vm._v("Hannibal’s monument in Turkey, commissioned by Atatürk. Author’s photograph.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-l"
  }, [_c('a', {
    attrs: {
      "href": "#/plates.htm#plate9"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("9.")])]), _vm._v("Bust of Hannibal (?) from Capua. Courtesy of the Mary Evans Picture Library.")]), _vm._v(" "), _c('p', {
    staticClass: "ahd"
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }), _vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "nl-f"
  }, [_c('a', {
    attrs: {
      "href": "#/maps.htm#map1"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("1.")])]), _vm._v("The central Mediterranean: Carthage, Rome and Sicily")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    attrs: {
      "href": "#/maps.htm#map2"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("2.")])]), _vm._v("The western Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "nl-l"
  }, [_c('a', {
    attrs: {
      "href": "#/maps.htm#map3"
    }
  }, [_c('span', {
    staticClass: "numblock"
  }, [_vm._v("3.")])]), _vm._v("Carthage and environs")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("All maps drawn by Stephen Copp.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f32b37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list_of_illustrations.vue
// module id = 72
// module chunks = 0